<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>
<div>
  <p class="title-section">Pozos Inyectores</p>
</div>

<div class="injector-cards">
  <div class="injector-card">
    <span class="card-text">Con fluido de</span>
    <mat-form-field class="inline-field narrow">
      <input matInput inputmode="numeric" name="fluidDensity"
        [(ngModel)]="pressure.fluidDensity"
        (change)="enableSaveButton(); onSectionTouched('annulusSpaces')"
        [disabled]="readOnlyContent" digitOnly [decimal]="true"
        pattern="^\d+(\.\d{1,3})?$" [min]="0" />
      <mat-hint class="unit">ppg</mat-hint>
    </mat-form-field>
    <span class="card-text">en el anular (entre Csg Guía y Csg Aislación) se puede aplicar una presión máxima en superficie de</span>
    <mat-form-field class="inline-field narrow">
      <input matInput inputmode="numeric" name="maxSurfacePressure"
        [(ngModel)]="pressure.maxSurfacePressure"
        (change)="enableSaveButton(); onSectionTouched('annulusSpaces')"
        [disabled]="readOnlyContent" digitOnly [decimal]="true"
        pattern="^\d+(\.\d{1,2})?$" [min]="0" />
      <mat-hint class="unit">psi</mat-hint>
    </mat-form-field>
    <span class="card-text">.</span>
  </div>
</div>

<div class="injector-cards">
  <div class="injector-card">
    <span class="card-text">Para una presión de inyección por casing de</span>
    <mat-form-field class="inline-field narrow">
      <input matInput inputmode="numeric" name="injectionPressure"
        [(ngModel)]="casingLoss.injectionPressure"
        (change)="enableSaveButton(); onSectionTouched('annulusSpaces')"
        [disabled]="readOnlyContent" digitOnly [decimal]="true"
        pattern="^\d+(\.\d{1,2})?$" [min]="0" />
      <mat-hint class="unit">psi</mat-hint>
    </mat-form-field>
    <span class="card-text">, el porcentaje máximo de pérdida de espesor de casing es de</span>
    <mat-form-field class="inline-field narrow">
      <input matInput inputmode="numeric" name="maxThicknessLossPercentage"
        [(ngModel)]="casingLoss.maxThicknessLossPercentage"
        (change)="enableSaveButton(); onSectionTouched('annulusSpaces')"
        [disabled]="readOnlyContent" digitOnly [decimal]="true"
        pattern="^\d+(\.\d{1,2})?$" [min]="0" [max]="100" />
      <mat-hint class="unit">%</mat-hint>
    </mat-form-field>
    <span class="card-text">.</span>
  </div>
</div>

<div class="injector-actions">
  <button mat-button class="save" title="Guardar" (click)="save()"
    [disabled]="isDisabled || readOnlyContent">
    <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
  </button>
</div>
